// Importar audios locales
import salvatoreAudio from '../../assets/audios/Salvatore-Mateo_Leiva.webm'
import steelDeerAudio from '../../assets/audios/Steel_Deer-José_Antonio_Galilea.webm'

const testimonialsData = {
    testimonialsTextSeller: [
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial1',
            name: 'Levi McFarland',
            role: 'seller',
            company: 'Playafitteas.cl',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: 'https://sitiodetiendas.com/blog/95',
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial2',
            name: 'María José Perandones',
            role: 'seller',
            company: 'Mooi',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: 'https://sitiodetiendas.com/blog/94',
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial3',
            name: 'Ángela Prat',
            role: 'seller',
            company: 'Polluelo',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial4',
            name: 'Gala Domínguez',
            role: 'seller',
            company: 'Dobakaru',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial5',
            name: 'Sergio Silva',
            role: 'seller',
            company: 'Palabodega Online',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial6',
            name: 'Leopoldo Vallenilla',
            role: 'seller',
            company: 'Caracas Mini Market',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial7',
            name: 'Mariana Bell',
            role: 'seller',
            company: 'Nwnormal',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial8',
            name: 'Tomás Monsalve',
            role: 'seller',
            company: 'Bicisport',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial9',
            name: 'Agustín Cabrales',
            role: 'seller',
            company: 'Delight',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial10',
            name: 'Marlenne Tapia',
            role: 'seller',
            company: 'Regala Chocolates',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial11',
            name: 'Fernando Casares',
            role: 'seller',
            company: 'Original Chalk',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial12',
            name: 'María de la Luz',
            role: 'seller',
            company: 'Chil Picnic',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial13',
            name: 'Julieta Kachizky',
            role: 'seller',
            company: 'Prem Studio',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial14',
            name: 'Francisca Valenzuela',
            role: 'seller',
            company: 'Kelim',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial15',
            name: 'Leandro Avelino',
            role: 'seller',
            company: 'Comercio al Toque',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial16',
            name: 'Ernesto Céspedes',
            role: 'seller',
            company: 'Red Peruana de Ferreterías',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial17',
            name: 'Rubén Fardella',
            role: 'seller',
            company: 'Tienda Sublime',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial18',
            name: 'Lucas Bontempi',
            role: 'seller',
            company: 'Unitar',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial19',
            name: 'María Paz Cortés',
            role: 'seller',
            company: 'Tara Publicidad',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial20',
            name: 'Marcos Diep',
            role: 'seller',
            company: 'Pedidos por Chat',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial21',
            name: 'Luis Padilla',
            role: 'seller',
            company: 'Hacelo App',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial22',
            name: 'Danilo Mora',
            role: 'seller',
            company: 'Radish Store',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial23',
            name: 'Jesica Santana',
            role: 'seller',
            company: 'Sinergia en Línea',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial24',
            name: 'Federico Franz',
            role: 'seller',
            company: 'La Nube Flash',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.seller.text.testimonial25',
            name: 'Carlos Bulacio',
            role: 'seller',
            company: 'Boreal',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
    ],

    testimonialsMediaSeller: [
        {
            type: 'video',
            text: 'homepage.testimonials.seller.video.testimonial1',
            name: 'Lemuun Tempesta',
            role: 'seller',
            company: 'Elegant',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url:
                'https://youtube.com/shorts/YoSZ3ti2Xq0?feature=share',
            youtube_embed_src:
                'https://youtube.com/embed/YoSZ3ti2Xq0?feature=share&enablejsapi=1',
            history_url: null,
            audio_url: null,
        },
        {
            type: 'video',
            text: 'homepage.testimonials.seller.video.testimonial2',
            name: 'Nathaly Calderón',
            role: 'seller',
            company: 'Cada cosa en su lugar',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url:
                'https://www.youtube.com/watch?v=n4YXM5tu2vk&t=39s',
            youtube_embed_src:
                'https://www.youtube.com/embed/n4YXM5tu2vk?start=39&enablejsapi=1',
            history_url: null,
            audio_url: null,
        },
        {
            type: 'video',
            text: 'homepage.testimonials.seller.video.testimonial3',
            name: 'Natalia Pérez',
            role: 'seller',
            company: 'Cherana',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url:
                'https://www.youtube.com/watch?v=RBjIRKkEmx8&t=34s',
            youtube_embed_src:
                'https://www.youtube.com/embed/RBjIRKkEmx8?start=34&enablejsapi=1',
            history_url: null,
            audio_url: null,
        },
        {
            type: 'audio',
            text: 'homepage.testimonials.seller.audio.testimonial1',
            name: 'Mateo Leiva',
            role: 'seller',
            company: 'Salvatore',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: salvatoreAudio, // 👉 Import directo del mp3,
        },
        {
            type: 'audio',
            text: 'homepage.testimonials.seller.audio.testimonial2',
            name: 'José Antonio Galilea',
            role: 'seller',
            company: 'Steel Deer',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: steelDeerAudio, // 👉 Import directo del mp3
        },
    ],

    testimonialsTextBuyer: [
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial1',
            name: 'Daniela Vaccareza',
            role: 'buyer',
            company: 'Calma Deco',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial2',
            name: 'Segundo Sosa',
            role: 'buyer',
            company: 'Boreal',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial3',
            name: 'Diego García',
            role: 'buyer',
            company: 'Nubeflash',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial4',
            name: 'Erik Untiveros',
            role: 'buyer',
            company: 'Caracas Mini Market',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial5',
            name: 'Micaela Doy',
            role: 'buyer',
            company: 'Vdeverde',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial6',
            name: 'Hernán Cid',
            role: 'buyer',
            company: 'Hacelo App',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial7',
            name: 'Ximena Gómez',
            role: 'buyer',
            company: 'Pedidos por Chat',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial8',
            name: 'Alonso Arrascue',
            role: 'buyer',
            company: 'Radish Store',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial9',
            name: 'Fer Álvaro',
            role: 'buyer',
            company: 'Sinergia en Línea',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial10',
            name: 'Tomás Guzmán',
            role: 'buyer',
            company: 'Cada Cosa en su Lugar',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial11',
            name: 'Pedro Butler',
            role: 'buyer',
            company: 'Moii Joyas',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial12',
            name: 'Javiera Pérez',
            role: 'buyer',
            company: 'Dobakaru',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial13',
            name: 'Eduardo Araya',
            role: 'buyer',
            company: 'Bicisport',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial14',
            name: 'Eilyn Roca',
            role: 'buyer',
            company: 'Regala Chocolates',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial15',
            name: 'Javier Pluta',
            role: 'buyer',
            company: 'Original Chalk',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial16',
            name: 'José Obrien',
            role: 'buyer',
            company: 'Comercio al Toque',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial17',
            name: 'Agustin López',
            role: 'buyer',
            company: 'Elegant',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial18',
            name: 'Ariel Nietze',
            role: 'buyer',
            company: 'Palabodega Online',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial19',
            name: 'Luis Santillana',
            role: 'buyer',
            company: 'Red Peruana de Ferreterías',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial20',
            name: 'Juan García',
            role: 'buyer',
            company: 'Tienda Sublime',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial21',
            name: 'Fernando Vanden',
            role: 'buyer',
            company: 'Unitar',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
        {
            type: 'text',
            text: 'homepage.testimonials.buyer.text.testimonial22',
            name: 'Camilo Lozano',
            role: 'buyer',
            company: 'Polluelo',
            rating: 5,
            image: null,
            video_url: null,
            youtube_video_url: null,
            youtube_embed_src: null,
            history_url: null,
            audio_url: null,
        },
    ],

    testimonialsMediaBuyer: []
}

export default testimonialsData
